import $ from "jquery";
import React, { Component } from "react";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { Redirect } from "react-router-dom";
import Comm from "../comm/comm";
import Context from "../context/context";
import Translation from "../translation/translation";

class Accounts extends Component {
    constructor(props) {
        super(props);
        if (!Comm.ValidSession()) return;

        if (!Context.IsLogged()) {
            return;
        }
        var sid = Context.GetContext().Sid;

        var accounts = Comm.Accounts(sid);

        this.state = {
            Accounts: accounts,
            SelectedAccount: null,
            showMissingBankError: false,
            showMissingBicError: false,
            showMissingIbanError: false,
            showMissingCurrencyError: false,
        };

        this.EditAccount = this.EditAccount.bind(this);
        this.NewAccount = this.NewAccount.bind(this);
        this.Save = this.Save.bind(this);
    }

    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return <Redirect to="/login" push></Redirect>;
        }

        if (Context.RenderNotOK(this.props.history)) return null;

        var accounts = this.state.Accounts.slice();

        var self = this;

        return Context.HasRight("raccounts") ? (
            <div className="panel panel-default">
                <div className="panel-heading">{Translation.Trans("accounts")}</div>
                <div className="panel-body">
                    {Context.HasRight("eaccounts") ? (
                        <button className="btn btn-primary" onClick={this.NewAccount}>
                            {Translation.Trans("newaccount")}
                        </button>
                    ) : null}

                    <br />
                    <br />
                    <br />
                    <div className="row">
                        <div className="col-md-12">
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th width="60%">{Translation.Trans("iban")}</th>
                                        <th width="40%">{Translation.Trans("currency")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {accounts.map((obj) => (
                                        <tr>
                                            <td width="60%">
                                                <span
                                                    className={
                                                        this.state.SelectedAccount !== null &&
                                                        this.state.SelectedAccount.id === obj.id
                                                            ? "btn btn-warning"
                                                            : null
                                                    }
                                                >
                                                    <a
                                                        onClick={() => self.EditAccount(obj)}
                                                        className="pointhand"
                                                    >
                                                        {obj.iban}
                                                    </a>
                                                </span>
                                            </td>
                                            <td width="40%">{obj.currency}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {this.state.SelectedAccount !== null ? (
                        <div className="col-md-12 borderDiv">
                            <div className="row">
                                <div className="col-md-3">
                                    <label className="control-label">{Translation.Trans("bank")}</label>
                                </div>
                                <div className="col-md-9">
                                    <input
                                        type="text"
                                        id="tbBank"
                                        className="form-control"
                                        defaultValue={this.state.SelectedAccount.bank}
                                        key={"bank" + this.state.SelectedAccount.id}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    {this.state.showMissingBankError ? (
                                        <div className="alert alert-danger">
                                            {Translation.Trans("entervalue")}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    <label className="control-label">{Translation.Trans("bic")}</label>
                                </div>
                                <div className="col-md-9">
                                    <input
                                        type="text"
                                        id="tbBic"
                                        className="form-control"
                                        defaultValue={this.state.SelectedAccount.bic}
                                        key={"bic" + this.state.SelectedAccount.id}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    {this.state.showMissingBicError ? (
                                        <div className="alert alert-danger">
                                            {Translation.Trans("entervalue")}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    <label className="control-label">{Translation.Trans("iban")}</label>
                                </div>
                                <div className="col-md-9">
                                    <input
                                        type="text"
                                        id="tbIban"
                                        className="form-control"
                                        defaultValue={this.state.SelectedAccount.iban}
                                        key={"iban" + this.state.SelectedAccount.id}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    {this.state.showMissingIbanError ? (
                                        <div className="alert alert-danger">
                                            {Translation.Trans("entervalue")}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    <label className="control-label">{Translation.Trans("currency")}</label>
                                </div>
                                <div className="col-md-9">
                                    <input
                                        type="text"
                                        id="tbCurrency"
                                        className="form-control"
                                        defaultValue={this.state.SelectedAccount.currency}
                                        key={"name" + this.state.SelectedAccount.id}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    {this.state.showMissingCurrencyError ? (
                                        <div className="alert alert-danger">
                                            {Translation.Trans("entervalue")}
                                        </div>
                                    ) : null}
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    {Context.HasRight("eaccounts") ? (
                                        <button className="btn btn-primary pull-right" onClick={this.Save}>
                                            {Translation.Trans("save")}
                                        </button>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>
        ) : (
            <div>{Translation.Trans("noRights")}</div>
        );
    }

    EditAccount(account) {
        this.setState({ SelectedAccount: account });
    }
    NewAccount() {
        this.setState({ SelectedAccount: {} });
    }

    Save() {
        this.setState({
            showMissingBankError: false,
            showMissingBicError: false,
            showMissingIbanError: false,
            showMissingCurrencyError: false,
        });
        var canSave = true;
        var bank = $("#tbBank").val();
        var bic = $("#tbBic").val();
        var iban = $("#tbIban").val();
        var currency = $("#tbCurrency").val();

        if (bank === "") {
            this.setState({ showMissingBankError: true });
            canSave = false;
        }
        if (bic === "") {
            this.setState({ showMissingBicError: true });
            canSave = false;
        }
        if (iban === "") {
            this.setState({ showMissingIbanError: true });
            canSave = false;
        }
        if (currency === "") {
            this.setState({ showMissingCurrencyError: true });
            canSave = false;
        }

        if (!canSave) return;

        var data = {};
        if (this.state.SelectedAccount.hasOwnProperty("id")) {
            data.id = this.state.SelectedAccount.id;
        }
        data.bank = bank;
        data.bic = bic;
        data.iban = iban;
        data.currency = currency;
        var sid = Context.GetContext().Sid;

        var postdata = {
            account: JSON.stringify(data),
            session: sid,
        };
        Comm.SaveAccount(postdata);

        var accounts = Comm.Accounts(sid);

        this.setState({
            Accounts: accounts,
            SelectedAccount: null,
            showMissingBankError: false,
            showMissingBicError: false,
            showMissingIbanError: false,
            showMissingCurrencyError: false,
        });
    }
}

export default Accounts;



// WEBPACK FOOTER //
// ./src/pages/accounts.js